/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useMutation } from "@tanstack/react-query";
import { notificarErroApi } from "utils/alertaCiencia";
import instance from "services/axiosServices";
import backofficeEnviroment from "utils/backofficeEnviroment";

interface Props {
  idLeadCorretor: string;
  idUnidade: string;
  series: {
    id: string;
    uniqueId: number;
    valorParcela?: number;
    dtVencimento: Date;
    tipoSerie: string;
  }[];
  frequencia?: number;
  qtdParcelas?: number;
  valorParcelaGeral?: number;
}

export function useEditarSerie() {
  const putData = async (props: Props) => {
    const EDITAR_SERIE = `${backofficeEnviroment}/common/oportunidades-lead/editar-serie/vivaz/v1`;
    const { data } = await instance.put(EDITAR_SERIE, {
      idLeadCorretor: props.idLeadCorretor,
      idUnidade: props.idUnidade,
      series: props.series,
      frequencia: props.frequencia,
      qtdParcelas: props.qtdParcelas,
      valorParcelaGeral: props.valorParcelaGeral,
    });
    return data;
  };

  const mutation = useMutation(putData, {
    onSuccess: () => {
      // toast.success("Série editada com sucesso!");
    },
    onError: (error: any) => {
      notificarErroApi("Erro ao editar série", error);
    },
  });

  return mutation;
}
